module.exports = __webpack_public_path__ + "img/Front.65220556.jpg";